
export default function FeaturesSection() {
  return (
    <section className="py-20 px-4 bg-gray-50">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-4xl font-bold text-center text-gray-800 mb-16">特典</h2>
        
        <div className="grid md:grid-cols-2 gap-6">
          {/* Feature 1 */}
          <div className="bg-white rounded-xl border border-teal-200 hover:shadow-lg transition-all duration-300 hover:border-teal-300 p-6">
            <div className="flex items-center mb-4">
              <div className="w-3 h-3 bg-teal-500 rounded-full mr-3"></div>
              <h3 className="text-xl font-semibold text-gray-800">
                リアル交流会参加費 
                <span className="text-teal-600 text-2xl font-bold ml-2">1,000円OFF</span>
              </h3>
            </div>
            <p className="text-gray-600">対面での交流会に特別価格でご参加いただけます</p>
          </div>

          {/* Feature 2 */}
          <div className="bg-white rounded-xl border border-teal-200 hover:shadow-lg transition-all duration-300 hover:border-teal-300 p-6">
            <div className="flex items-center mb-4">
              <div className="w-3 h-3 bg-teal-500 rounded-full mr-3"></div>
              <h3 className="text-xl font-semibold text-gray-800">
                月1回オンライン交流会
                <span className="text-teal-600 text-lg font-bold ml-2">（無料）</span>
              </h3>
            </div>
            <p className="text-gray-600">毎月開催されるオンライン交流会に無料でご参加いただけます</p>
          </div>

          {/* Feature 3 */}
          <div className="bg-white rounded-xl border border-teal-200 hover:shadow-lg transition-all duration-300 hover:border-teal-300 p-6">
            <div className="flex items-center gap-3">
              <div className="w-3 h-3 bg-teal-500 rounded-full"></div>
              <span className="text-lg text-gray-800">起業家支援プログラム</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
